import { HeorotThemeColors } from 'projects/heorot/src/assets/heorot-theme.colors';
import { createThemePreset } from 'projects/shared/src/lib/style/configuration/theme-color.facrory';

export const HeorotPreset = createThemePreset(HeorotThemeColors);
